import { z } from "zod";

import {
  seoGeoFields,
  systemFields,
  zDate,
  zGenreRef,
  zMedia,
  zTransliterations,
} from "@/lib/zod/show-fragments";

/** Read-only view schema for the Screenings show page — full ScreeningDbDto. */
export const screeningViewSchema = z
  .object({
    id: z.string(),
    movie: z
      .object({
        id: z.string().nullish(),
        title: z.string().nullish(),
        media: zMedia.nullish(),
        durationInMinutes: z.number().nullish(),
        genres: z.array(zGenreRef).nullish(),
      })
      .passthrough()
      .nullish(),
    venue: z
      .object({
        id: z.string().nullish(),
        name: z.string().nullish(),
        slug: z.string().nullish(),
        media: zMedia.nullish(),
        geolocation: z
          .object({ lat: z.number().nullish(), lng: z.number().nullish() })
          .passthrough()
          .nullish(),
        address: z.string().nullish(),
        area: z.string().nullish(),
        mapsUrl: z.string().nullish(),
        status: z.string().nullish(),
        timezone: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    startDate: zDate,
    endDate: zDate,
    format: z
      .object({
        is3D: z.boolean().nullish(),
        language: z.string().nullish(),
        subtitles: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    screen: z.any().nullish(),
    // Set by Tina each time it reads this screening's price on the source page. Read-only.
    priceCheckedAt: zDate,
    pricing: z
      .array(
        z
          .object({
            label: z.string().nullish(),
            amount: z.number().nullish(),
            currency: z.string().nullish(),
          })
          .passthrough(),
      )
      .nullish(),
    status: z.string().nullish(),
    enrichmentStatus: z.string().nullish(),
    enrichment: z
      .object({
        ...seoGeoFields,
        transliterations: zTransliterations.nullish(),
      })
      .passthrough()
      .nullish(),
    tags: z.array(z.string()).nullish(),
    hide: z.boolean().nullish(),
    ...systemFields,
  })
  .passthrough();

export type ScreeningViewType = z.infer<typeof screeningViewSchema>;
